module.exports = __webpack_public_path__ + "static/media/vinicius-pecanha.11f8dbee.png";